// removed by extract-text-webpack-plugin
module.exports = {"LoadingModalContent":"LoadingModal__LoadingModalContent__30CoO","loadiingMessage":"LoadingModal__loadiingMessage__yY5_V"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/LoadingModal/LoadingModal.css
// module id = 601
// module chunks = 0